import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

const AboutPage = () => {
  const { settings } = useSettings();

  return (
    <div className="min-h-screen bg-brand-light pt-20 md:pt-24">
      {/* Masthead */}
      <div className="py-16 md:py-24 px-4 md:px-6 lg:px-8 border-b border-brand-main/20">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-display text-6xl md:text-7xl italic font-light text-brand-ink">
            L'Artista
          </h1>
        </div>
      </div>

      {/* Story Section */}
      <div className="py-20 md:py-28 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
            {/* Image */}
            <div className="order-2 md:order-1">
              <div className="aspect-square rounded-lg overflow-hidden bg-brand-main shadow-lg">
                <img
                  src={settings.artist_photo_url || 'https://via.placeholder.com/400'}
                  alt={settings.artist_name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Text */}
            <div className="order-1 md:order-2">
              <h2 className="font-display text-4xl md:text-5xl italic font-light text-brand-ink mb-6">
                {settings.artist_name}
              </h2>
              <div className="font-body text-lg text-brand-muted leading-relaxed space-y-4">
                {settings.about_story.split('\n\n').map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Philosophy Section */}
      <div className="bg-brand-main/10 py-20 md:py-28 px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-display text-4xl md:text-5xl italic font-light text-brand-ink mb-12 text-center">
            {settings.about_philosophy_label}
          </h2>
          <div className="border-l-2 border-brand-main pl-6">
            <div className="font-body text-lg text-brand-muted leading-relaxed space-y-4">
              {settings.about_philosophy.split('\n\n').map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      {settings.testimonials && settings.testimonials.length > 0 && (
        <div className="py-20 md:py-28 px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {settings.testimonials_label && (
              <h2 className="font-display text-4xl md:text-5xl italic font-light text-brand-ink mb-12 text-center">
                {settings.testimonials_label}
              </h2>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {settings.testimonials.map((t, idx) => (
                <div key={idx} className="bg-white rounded-xl p-6 border border-brand-main/30 shadow-sm flex flex-col gap-4">
                  <p className="font-body text-brand-muted leading-relaxed italic flex-1">
                    "{t.text}"
                  </p>
                  <div className="border-t border-brand-main/20 pt-3">
                    <p className="font-medium text-brand-dark text-sm">{t.name}</p>
                    {t.role && <p className="text-xs text-brand-muted mt-0.5">{t.role}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <div className="py-20 md:py-28 px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-display text-5xl md:text-6xl italic font-light text-brand-ink mb-6">
            Vieni a scoprire le mie opere
          </h2>
          <Link
            to="/galleria"
            className="inline-flex items-center gap-2 bg-brand-dark text-white px-8 py-3 rounded-full font-medium hover:bg-opacity-90 transition-all"
          >
            Visita la Galleria
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
